import React from 'react'
import cx from 'classnames'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, l } from '@manychat/manyui'

import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'

import cm from './SidebarHeader.module.css'

interface SidebarHeaderProps {
  title?: string
  showCloseButton?: boolean
  button?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export const SidebarHeader = ({
  title,
  showCloseButton = true,
  button,
  children,
  className,
}: SidebarHeaderProps) => {
  const dispatch = useAppDispatch()

  const closeSidebar = () => {
    dispatch(AiAutomationLayoutActions.sidebarClosed())
  }

  return (
    <header
      className={cx(
        cm.sidebarHeader,
        {
          [cm.sidebarHeader_withHeaderButton]: Boolean(button),
          [cm.sidebarHeader_closeButtonOnly]: !title,
        },
        className,
      )}
    >
      <div className={cm.sidebarHeader__mainContent}>
        {showCloseButton && (
          <BtnV2
            onClick={closeSidebar}
            variant="ghost-light"
            className={cm.sidebarHeader__mobileCloseButton}
            onlyIcon="ChevronLeft"
            ariaLabel={l.translate('Close sidebar')}
          />
        )}

        <h2 className={cm.sidebarHeader__title}>{title}</h2>

        {button && <div className={cm.sidebarHeader__passedButton}>{button}</div>}

        {showCloseButton && (
          <BtnV2
            onClick={closeSidebar}
            variant="ghost-light"
            className={cm.sidebarHeader__closeButton}
            onlyIcon="Close"
            ariaLabel={l.translate('Close sidebar')}
            data-test-id="ai-automation/sidebar-close-button"
          />
        )}
      </div>

      {children}
    </header>
  )
}
